import React from 'react';
import { ContractTextInput } from './ContractFields';
import { usePriceContext } from 'contracts/utils/priceContext';
import { ContractCheckbox } from './ContractFields';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: none;
`;
const OpportunityFixedPrice = () => {
  const {
    opportunityPriceUsdLb,
    opportunityFixedPrice,
    opportunityPricesUsdToCustomerRate,
    modifiedExchangeRate,
    contractPricesUsdToCustomerRate,
    contractPricesCustomerToUsdRate,
    sameCurrency,
    sameCurrencyUnitofMeasure,
    exchangeRate,
    contractType,
  } = usePriceContext();

  const handleRateChange = (value) => {
    modifiedExchangeRate?.set(value);
    if (!value && exchangeRate) {
      contractPricesUsdToCustomerRate?.set(exchangeRate.toString());
      contractPricesCustomerToUsdRate?.set((1 / exchangeRate).toString());
    }
  };
  return (
    <>
      {contractType != 'LocalContract' && (
        <>
          {opportunityPricesUsdToCustomerRate && !sameCurrency && (
            <ContractTextInput field={opportunityPricesUsdToCustomerRate.field} />
          )}
          {opportunityPriceUsdLb && !sameCurrencyUnitofMeasure && (
            <ContractTextInput field={opportunityPriceUsdLb.field} />
          )}

          {opportunityFixedPrice && (
            <ContractTextInput field={opportunityFixedPrice.field} />
          )}

          {contractPricesUsdToCustomerRate && !sameCurrency && (
            <StyledWrapper>
              <ContractTextInput
                field={contractPricesUsdToCustomerRate.field}
                value={contractPricesUsdToCustomerRate.value}
                onChange={contractPricesUsdToCustomerRate.set}
                readOnly={!modifiedExchangeRate?.value}
                type='number'
                step='0.0001'
                min='0.0001'
              />
            </StyledWrapper>
          )}

          {contractPricesCustomerToUsdRate && !sameCurrency && (
            <ContractTextInput
              field={contractPricesCustomerToUsdRate.field}
              value={contractPricesCustomerToUsdRate.value}
              onChange={contractPricesCustomerToUsdRate.set}
              readOnly={!modifiedExchangeRate?.value}
              type='number'
              step='0.0001'
              min='0.0001'
            />
          )}
          {modifiedExchangeRate && !sameCurrency && (
            <ContractCheckbox
              field={modifiedExchangeRate.field}
              checked={modifiedExchangeRate.value}
              onChange={handleRateChange}
            />
          )}
        </>
      )}
      {contractType == 'LocalContract' && (
        <>
          {contractPricesCustomerToUsdRate && !sameCurrency && (
            <div style={{ visibility: 'hidden' }}>
              <ContractTextInput
                field={contractPricesCustomerToUsdRate.field}
                value={contractPricesCustomerToUsdRate.value}
                onChange={contractPricesCustomerToUsdRate.set}
                readOnly={!modifiedExchangeRate?.value}
                type='number'
                step='0.0001'
                min='0.0001'
              />
            </div>
          )}
          {opportunityFixedPrice && !sameCurrencyUnitofMeasure && (
            <ContractTextInput field={opportunityFixedPrice.field} />
          )}
          {opportunityPriceUsdLb && (
            <ContractTextInput field={opportunityPriceUsdLb.field} />
          )}
        </>
      )}
    </>
  );
};

export default OpportunityFixedPrice;
